<template>
<div id="hero">
<AppNavigation textColor='#fff' from='home'/>

   <div id="banner" class="d-flex flex-wrap align-content-center justify-content-center">
        <div class="container-fluid">
          <div class="row align-content-center m-0 p-0" >
            <div class="col-4 side-image-left-container">
              <img class="side-image-left img-fluid" src="../assets/images/circle-white.png" alt="" >
            </div>
            <div class="col-12 text-center hero-text justify-content-center align-items-center">
              <div class="row justify-content-center">
                <div class="" >
                  <h2 class="text-center">
                    <span>Digital Voucher</span> <br>
                    <span>Disbursement Platform</span>
                  </h2>
                  <a class="btn btn-outline-light p-3 my-4" style="font-weight:bold" href="#signUp">Get Started</a>
              </div>
              </div>
            </div>
            <div class="col-4 side-image-right-container">
              <img  class="side-image-right img-fluid" src="../assets/images/circle-white.png" alt="" >
            </div>
          </div>
        </div>
      </div>
</div>
</template>

<script>
import AppNavigation from '../components/AppNavigation'
export default {
components: {
    AppNavigation,
}
}
</script>

<style scoped>
/*------- banner -------*/
#banner{
  height:100%;
}
.side-image-left-container{
  position:absolute;
  left: -18%;
  top:60px;
}
.side-image-right-container{
  position:absolute;
  bottom:10px;
  right:-19%;
} 
.hero-text h2{
  color:#fff;
  font-weight: 700;
  font-size: 4em;
}
.hero-text button{
  margin:1.5em;
  padding:10px;
}
@media screen and (max-width:420px) {
.hero-text h2{
  font-weight: 500;
  font-size: 3em;
}  
}
</style>